import * as v from "valibot";

import { rpcContract } from "../rpc";

export const publicPostDetailQueryRpcContract = rpcContract({
  name: "publicPostDetailQuery",
  paramsSchema: v.object({
    postId: v.string(),
    worldId: v.optional(v.string()),
  }),
  resultSchema: v.object({
    id: v.string(),
    title: v.nullable(v.string()),
    description: v.string(),
    imageUrl: v.nullable(v.string()),
    ctaButton: v.nullable(
      v.object({
        text: v.string(),
        url: v.string(),
      }),
    ),
    discountData: v.nullable(
      v.object({
        code: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
      }),
    ),
    faqBlocks: v.nullable(
      v.array(
        v.object({
          question: v.pipe(v.string(), v.minLength(1), v.maxLength(150)),
          answer: v.pipe(v.string(), v.minLength(1), v.maxLength(250)),
        }),
      ),
    ),
    user: v.object({
      avatarUrl: v.nullable(v.string()),
    }),
    createdAt: v.string(),
    worldName: v.optional(v.string()),
    contentTier: v.union([v.literal("free"), v.literal("premium")]),
    hasAccess: v.boolean(),
    influencerId: v.string(),
    oneTimeProduct: v.optional(
      v.object({
        id: v.string(),
        priceCents: v.number(),
      }),
    ),
  }),
});

export type PublicPostDetailQueryParams = v.InferOutput<(typeof publicPostDetailQueryRpcContract)["paramsSchema"]>;
export type PublicPostDetailQueryResult = v.InferOutput<(typeof publicPostDetailQueryRpcContract)["resultSchema"]>;
export type PublicPostDetail = v.InferOutput<(typeof publicPostDetailQueryRpcContract)["resultSchema"]>;
